import { render, staticRenderFns } from "./VaTreeCategory.demo.vue?vue&type=template&id=504b4474&"
import script from "./VaTreeCategory.demo.vue?vue&type=script&lang=js&"
export * from "./VaTreeCategory.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports